"use strict";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
export const ScrollToTop = () => {
  const $ = _c(2);
  const {
    pathname
  } = useLocation();
  let t0;
  if ($[0] !== pathname) {
    t0 = [pathname];
    $[0] = pathname;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  useEffect(_temp, t0);
  return null;
};
function _temp() {
  window.scrollTo(0, 0);
}